import { render, staticRenderFns } from "./EntityAdditionalBanners.vue?vue&type=template&id=0a7872d2&scoped=true"
import script from "./EntityAdditionalBanners.vue?vue&type=script&lang=js"
export * from "./EntityAdditionalBanners.vue?vue&type=script&lang=js"
import style0 from "./EntityAdditionalBanners.vue?vue&type=style&index=0&id=0a7872d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7872d2",
  null
  
)

export default component.exports